<tmo-dynamic-modal [displayModal]="displayModal" [modal]="modal">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeTaxExemptionModal()"
        id="cta-default-216"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
    <h3>{{ aemContent?.taxExemption }}</h3>
  </ng-container>
  <p class="small">{{ aemContent?.taxExemptOrganization }}</p>
  <form [formGroup]="taxExemptionFormGroup">
    <div class="col-8 col-md-10 col-lg-10 m-t-md">
      <div class="row">
        <div class="col-8 n-padding">
          <tmo-textarea
            formControlName="taxExemptionText"
            [placeholder]="aemContent?.clickToEnter"
            cols="10"
            rows="5"
            [id]="'tmo-textarea-tax-exemption-text'"
          ></tmo-textarea>
        </div>
      </div>
    </div>
  </form>
  <ng-container footer>
    <div class="row">
      <div class="col-12 buttons-container button-spacing">
        <div class="button-box">
          <button class="btn btn-secondary" (click)="closeTaxExemptionModal()" id="btn-default-258">
            {{ aemContent?.cancel }}
          </button>
        </div>
        <div class="button-box">
          <button
            class="btn btn-primary"
            [disabled]="!taxExemptionFormGroup.valid"
            (click)="isOrderReview ? exemptTaxOnReviewOrder() : saveToOrder()"
            id="btn-default-259"
          >
            {{ aemContent?.save }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
